//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import {Link} from 'react-router-dom'
//@end

//@import components
import AllNewsModuleSkeleton from 'app_components/modules/newsEvents/allnews/components/allNewsModuleSkeleton';
import NewsCardComponent from 'app_components/commons/newsCard'
import TagsCommon from 'app_components/commons/tags'
import AlertComponent from 'app_components/commons/alert/containers/alertComponent';
import PaginationComponent from 'app_components/commons/pagination'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../allnewsModule.scss'

// @ADD Component types
interface IAllnewsModuleLayoutProps {
  tags: Array<any>
  news: Array<any>
	loading: boolean
  pagination: IPagination
  onPageChange?: (page: number) => void
  onChangeTag?: (tag: any) => void
}

const AllnewsModuleLayout: React.FC<IAllnewsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className={'all-news'}>
      {props.loading ? (
        <AllNewsModuleSkeleton />
      ) : (
        <>
          {props.news && props.news.length > 0 ? (
            <>
              <div className='all-news--container-cards'>
                {props.news.map((n) => (
                    <div key={n.key}>
                      <Link to={routingService.getPublicPath(`/noticia/${n.slug}`)}>
                        <NewsCardComponent {...n} />
                      </Link>
                    </div>
                  ))
                }
              </div>
              {props.pagination && (
                <div className="row">
                  <div className="col-12">
                    <PaginationComponent data={props.pagination} onChangePage={props.onPageChange} />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div>
              <AlertComponent
                type='warning'
                title={t('modules.news.no_data')}
              />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default AllnewsModuleLayout
